module.exports = __webpack_public_path__ + "static/media/plannen.e6accb2c.svg";